var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar"},[_c('ul',{staticClass:"baritems"},[_c('router-link',{attrs:{"to":"/super/orgs"}},[_c('li',[_vm._v("Customer Management")])]),_c('router-link',{attrs:{"to":"/super/users"}},[_c('li',[_vm._v("User Management")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }